<template>
  <div>
    <b-button
      v-permission="'reporting_channel_handling.configuration.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew"
    >
      <feather-icon icon="PlusIcon" class="mr-50" />
      <span class="align-middle">{{ $t('AddNew') }}</span>
    </b-button>
    <Grid
      :service="service"
      route_name="handling_status_configuration_index"
      route_grid_path="grid"
      defaultOrderColumn="id"
      defaultOrderDirection="desc"
      :ref="'grid'"
    >
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="description" sort-key="description">{{
          $t('reporting_channel.workflow_config.description')
        }}</vs-th>
        <vs-th key="legal_entity_name" sort-key="legal_entity_id">{{
          $t('reporting_channel.workflow_config.legal_entity')
        }}</vs-th>
        <vs-th key="created_at" sort-key="created_at">{{
          $t('reporting_channel.workflow_config.created_at')
        }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td key="description">
            <div>{{ tr.description || '-' }}</div>
          </vs-td>
          <vs-td key="legal_entity_name">
            <div>{{ tr.legal_entity_name || 'Global' }}</div>
          </vs-td>
          <vs-td key="created_at">
            <div>{{ $utils.format.date(tr.created_at) }}</div>
          </vs-td>
          <vs-td>
            <slot
              name="actions"
              :row="tr"
              :data="props.data"
              :indextr="indextr"
              :methods="{ edit: props.edit, destroy: props.destroy }"
            >
              <div class="flex flex-row gap-2">
                <feather-icon
                  v-permission="`reporting_channel_handling.configuration.edit`"
                  icon="EditIcon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                  v-tooltip.top="{
                    content: 'Editar configuração',
                    delay: { show: 100, hide: 100 }
                  }"
                  @click="edit(tr.id)"
                />
                <feather-icon
                  v-permission="
                    `reporting_channel_handling.configuration.delete`
                  "
                  icon="Trash2Icon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                  v-tooltip.top="{
                    content: 'Excluir configuração',
                    delay: { show: 100, hide: 100 }
                  }"
                  @click="destroy(tr.id)"
                />
              </div>
            </slot>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ReportingChannelWorkflowConfigService from '@/services/api/reporting-channel/ReportingChannelWorkflowConfigService'

export default {
  directives: {
    Ripple
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    grid() {
      return this.$refs['grid']
    },
    addNew() {
      this.$router.push('/reporting-channel/config/create')
    },
    edit(id) {
      this.$router.push(`/reporting-channel/config/${id}/edit`)
    },
    destroy(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir esta configuração?',
        accept: () => {
          this.destroyModel(id)
        }
      })
    },
    destroyModel(id) {
      this.$vs.loading()
      this.service
        .destroy(id)
        .then(
          response => {
            this.notifySuccess(this.$vs, 'Configuração excluída com sucesso!')
            this.grid().fetchGridData()
          },
          error => {
            this.notifyError(
              this.$vs,
              'Não foi possível excluir a configuração'
            )
          }
        )
        .finally(() => this.$vs.loading.close())
    }
  },
  beforeMount() {
    this.service = ReportingChannelWorkflowConfigService.build(this.$vs)
  }
}
</script>
